import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';

import GeofenceEditor from './GeofenceEditor';

const mapStateToProps = (state, ownProps) => {

    return {
        color: geofences.Selectors.geofenceColor(state, ownProps.geofenceId),
        colorStatus: geofences.Selectors.geofenceStyleChangePending(state, ownProps.geofenceId) ? 'PENDING' : '',

        location: geofences.Selectors.geofenceCoordinates(state),
        radiusInKm: geofences.Selectors.geofenceRadiusInKm(state),
        saving: geofences.Selectors.savingGeometryEdit(state, ownProps.geofenceId),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onGeofenceAddressChange: (address) => dispatch(
            geofences.Actions.editGeofenceAddress(address)
        ),
        onGeofenceLocationChange: (coordinates) => dispatch(
            geofences.Actions.editGeofenceCoordinates(coordinates)
        ),
        onGeofenceRadiusChange: (radiusInKm) => dispatch(
            geofences.Actions.editGeofenceRadiusInKm(radiusInKm)
        ),
        saveChanges: () => dispatch(
            geofences.Actions.saveGeometryEdit(ownProps.stage, ownProps.geofenceId)
        ),
        cancelChanges: () => dispatch(
            geofences.Actions.cancelGeometryEdit()
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeofenceEditor);
